import SpendingChart from '../../components/charts/SpendingChart';
import { DateRangePicker } from '../../components/DateRangePicker';
import Entity from '../../components/entity';
import LargestTransactions from '../../components/LargestTransactions';
import TransactionsTable, { TxnTableElementType } from '../../components/tables/TransactionsTable';
import { useFilteredTransactions } from '../../hooks/useFilteredTransactions';
import { useDateRangeParams } from '../../providers/DateRangeProvider';

const SpendingPane = () => {
  // Date range synced with URL
  const [dateRange, setDateRange] = useDateRangeParams();

  const { transactions, loading: transactionsLoading } = useFilteredTransactions();

  return (
    <Entity.Pane>
      <Entity.Header
        title="Spending"
        trailingContent={<DateRangePicker value={dateRange} onChange={setDateRange} defaultValue="past6Months" />}
      />
      <Entity.Body
        primaryElement={
          <SpendingChart
            transactions={transactions}
            dateRange={dateRange}
            onDateRangeChange={setDateRange}
            isLoading={transactionsLoading}
          />
        }
        leftColumn={
          <TransactionsTable
            dateRange={dateRange}
            onDateRangeChange={setDateRange}
            primaryElement={TxnTableElementType.Merchant}
            secondaryElement={TxnTableElementType.Account}
          />
        }
        rightColumn={<LargestTransactions dateRange={dateRange} />}
      />
    </Entity.Pane>
  );
};

export default SpendingPane;
